module.exports = {"title":"APL Real-Time Status","statsBaseTime":"{time} (statistics reference time)","byClubCount":"<By golf club count>","total":"Total","normal":"Normal","abnormal":"Abnormal","normalOperationRate":"Normal Operation Rate","progressStatus":"Progress","aplDeviceRate":"APL Device Operation Rate","normalOfTotal":"Normal {normal} / Total {total}","regionGyeonggiIncheon":"Gyeonggi/Incheon","regionChungbuk":"Chungbuk","regionChungnam":"Chungnam","regionJeolla":"Jeolla","regionGyeongbuk":"Gyeongbuk","regionGyeongnam":"Gyeongnam","regionGangwon":"Gangwon","regionJeju":"Jeju"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/ho201.json
// module id = 4SjR
// module chunks = 2